import React from "react";
import style from "./Home.module.css";
import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { QtdContext } from "../../../context/qtdContext";
import Button from '../../../components/Button/Button'
import 'react-tabs/style/react-tabs.css';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { FcCancel, FcEngineering } from "react-icons/fc";
import $api from '../../../http/index.ts'
import './react-confirm-alert.css'; // Import css
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { useEffect, useState, useContext } from "react";
import LinksMenu from "../../../components/Header/LinksMenu";
// import AddProductModal from "../../../components/Modals/AddProductModal";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { BACKURL } from '../../../conf.js'
import Loading from 'react-fullscreen-loading';
import AddEmployeesModal from "../../../components/Modals/Emloyees/AddEmployeesModal.js";
import EditEmployeesModal from "../../../components/Modals/Emloyees/EditEmployeesModal.js";
import AddContrAgentsModal from "../../../components/Modals/ContrAgents/AddContrAgentsModal.js";
import EditShopKassasModal from "../../../components/Modals/ShopKassas/EditShopKassasModal.js";

const ShopKassas = () => {
  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // месяцы с 0
    const year = String(d.getFullYear()).slice(-2); // последние две цифры года
    return `${day}.${month}.${year}`;
  };
  const [expandedId, setExpandedId] = useState(null);
  const { incosations, shopvneseneenal, editShopKassasModal, setEditShopKassasModal, shopKassas, setShopKassas, contragents, Notify, editEmployeesModal, addContrAgentsModal, setAddContrAgentsModal, setEditEmployeesModal, admin, admins, setAdmins, addEmployeesModal, setAddEmployeesModal, setDashboarPage, shops } = useContext(QtdContext);
  const [loading, seloading] = useState(false)
  const [id, setId] = useState('')
  const OpnaEditModal = (id) => {
    setId(id)
    setEditShopKassasModal(id)
  }
  const submit = async (func, id) => {
    confirmAlert({
      title: 'Удалить кассу',
      message: 'Вы уверены, что хотите удалить кассу из системы?',
      buttons: [
        {
          label: 'Да!',
          onClick: async () => await func(id)
        },
        {
          label: 'Отмена!',
          //   onClick: () => alert('Click No')
        }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
    });
  };
  const deleteIt = async (id) => {
    try {
      seloading(true)

      const deleteProd = await $api.get(`${BACKURL}/api/shopkassas/delete/${id}`)
      setShopKassas(shopKassas.filter(item => item.id != id))
      seloading(false)

      Notify.addNotification({
        title: "Готово!",
        message: "Сотрудник успешно удален из системы!",
        type: "success",
        insert: "bottom",
        container: "bottom-center",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
    } catch (e) {
      console.log(e)
      seloading(false)

      Notify.addNotification({
        title: "Ошибка!",
        message: "Произошла непредвиденная ошибка!",
        type: "danger",
        insert: "bottom",
        container: "bottom-center",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      })
    }
  }
 const InnerAccordion = ({ kassa, shop, expandedId, setExpandedId }) => {
  const isExpanded = expandedId === kassa.id;
  const incosationsShop = incosations.filter(pr => pr.shop_id == shop.id);
  const shopvneseneenalShop = shopvneseneenal.filter(pr => pr.shop_id == shop.id);

  return (
    <Accordion
      allowZeroExpanded
      preExpanded={isExpanded ? [kassa.id] : []}
      onChange={ids => {
        if (ids.includes(kassa.id)) {
          setExpandedId(kassa.id);
        } else {
          setExpandedId(null);
        }
      }}
      style={{ width: '100%' }}
    >
      <AccordionItem uuid={kassa.id}>
        <AccordionItemHeading>
          <AccordionItemButton style={{ padding: 0 }}>
            {/* Аккордеон Заголовок */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className={style.tabletd}>{kassa.id}</div>
              <div className={style.tabletd}>{shop.name}</div>
              <div className={style.tabletd}>{kassa.money}руб</div>
              <div className={style.tabletd} style={{ display: 'flex', justifyContent: 'space-around' }}>
                <div className={style.cell}>
                  <FcEngineering onClick={() => OpnaEditModal(kassa.id)} />
                </div>
                <div className={style.cell}>
                  <FcCancel onClick={() => submit(deleteIt, kassa.id)} />
                </div>
              </div>
            </div>
          </AccordionItemButton>
        </AccordionItemHeading>

        <AccordionItemPanel style={{ background: 'wheat' }}>
          {/* Контент панели */}
          <div style={{ display: 'flex', width: '100%', flexDirection: 'row', alignItems: 'start' }}>
            {/* Инкассации */}
            <div style={{ display: 'flex', width: '50%', flexDirection: 'column', alignItems: 'start' }}>
              <h4>Инкассации</h4>
              {incosationsShop.map(s_i => { 
                const icstr = admins.find(pr=>pr.id==s_i.admin_id)
                return(
                <div key={s_i.id} style={{ display: 'flex',fontSize:'10px', width: '100%', flexDirection: 'row', alignItems: 'start' }}>
                  <div style={{ width: '30%' }}>{formatDate(s_i.createdAt)}</div>
                  <div style={{ width: '30%' }}><b>{icstr.fullname.split(' ')[0]}</b></div>
                  <div style={{ width: '30%' }}><b style={{color:'red'}}>{s_i.money}руб</b></div>
                </div>
              )})}
            </div>
  {/* {user.fullname.split(' ')[0]} */}
            {/* Внесения */}
            <div style={{ display: 'flex', width: '50%', flexDirection: 'column', alignItems: 'start' }}>
              <h4>Внесения</h4>
              {/* {shopvneseneenalShop.map(s_i => ( */}
              {shopvneseneenalShop.map(s_i => { 
                const icstr = admins.find(pr=>pr.id==s_i.admin_id)
                return(
                <div key={s_i.id} style={{ display: 'flex',fontSize:'10px', width: '100%', flexDirection: 'row', alignItems: 'start',justifyContent:'space-between' }}>
                  <div style={{ width: '30%' }}>{formatDate(s_i.createdAt)}</div>
                  <div style={{ width: '30%' }}><b>{icstr.fullname.split(' ')[0]}</b></div>
                  <div style={{ width: '30%' }}><b style={{color:'green'}}>{s_i.money}руб</b></div>
                </div>
              )})}
            </div>
          </div>
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  );
};

  if (!(admin.role == 'AllRights' || admin.role == 'Администратор')) {
    setDashboarPage('Home')
    // setAdmin({ auth: false});
    return <Navigate to="/" replace />

  } else {

    // console.log(admin.role != 'GOD' && admin.role != 'Администратор')
    // useEffect(()=>{})
    const users = admins.filter(pr => pr.role != 'AllRights')
    const sorted = users.sort((a, b) => a.fullname > b.fullname ? 1 : -1);
    const addProduct = () => {
      setAddContrAgentsModal(true)
    }

    // useEffect(())





    return (<>

      <div className={style.sclad_container}>
        {/* <Button text='Создать Контрагента' background='orange' onClick={addProduct} /> */}

        <div className={style.table2}>
          {/* <table className={style.table}>
            <thead className={style.tableth}>

              <tr>
                <td className={style.tabletd}>№</td>
                <td className={style.tabletd}>Точка</td>
                <td className={style.tabletd}>Остаток</td>
                {/* <td className={style.tabletd}>inn</td>
                <td className={style.tabletd}>Договор</td>
                <td className={style.tabletd}>Банк</td> */}

          {/* <td className={style.tabletd}>Действия</td>
              </tr>
            </thead>
            <tbody>  */}
          {shopKassas.map(employee => {
            const shop = shops.find(gg => gg.id == employee.shop_id)

            return (
              <InnerAccordion
      key={employee.id}
      kassa={employee}
      shop={shop}
      expandedId={expandedId}
      setExpandedId={setExpandedId}
    />
         
            )
          }
          )}


          {/* 
            </tbody>
          </table> */}
        </div>

      </div>

      {editShopKassasModal && (
        <EditShopKassasModal
          id={id}

        />

      )}
      {addContrAgentsModal && (
        <AddContrAgentsModal

        />

      )}

      {loading && (
        <Loading loading background="rgba(255, 165, 0,0.75)" loaderColor="#3498db"></Loading>
      )}


    </>
    );
  }


};

export default ShopKassas;
